export enum StoreKey {
	APP = 'app',
	PILOT_EXPENSES = 'pilotExpenses',
}
